import { render } from "./IconUser.vue?vue&type=template&id=296e4f62"
import script from "./IconUser.vue?vue&type=script&lang=js"
export * from "./IconUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__